/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
	DataTag,
	DefinedInitialDataOptions,
	DefinedUseQueryResult,
	MutationFunction,
	QueryClient,
	QueryFunction,
	QueryKey,
	UndefinedInitialDataOptions,
	UseMutationOptions,
	UseMutationResult,
	UseQueryOptions,
	UseQueryResult
} from '@tanstack/react-query';

import { customInstance } from '.././instance';
import type { ErrorType } from '.././instance';
import type {
	EmailRequest,
	MessageResponse,
	PraetoidError,
	ProviderResponse,
	ResetPasswordRequest,
	SignInOAuthCallbackParams,
	SignInRequest,
	SignUpRequest,
	SuccessResponse,
	UpdateEmailRequest,
	UpdatePasswordRequest,
	User
} from '../models';

/**
 * Returns the currently authenticated user's information
 * @summary Get current user
 */
export const user = () => {
	return customInstance<User>({ url: `/account`, method: 'GET' });
};

export const getUserQueryKey = () => {
	return ['account'] as const;
};

export const getUserQueryOptions = <
	TData = Awaited<ReturnType<typeof user>>,
	TError = ErrorType<PraetoidError>
>(options?: {
	query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof user>>, TError, TData>>;
}) => {
	const { query: queryOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getUserQueryKey();

	const queryFn: QueryFunction<Awaited<ReturnType<typeof user>>> = () => user();

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof user>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type UserQueryResult = NonNullable<Awaited<ReturnType<typeof user>>>;
export type UserQueryError = ErrorType<PraetoidError>;

export function useUser<
	TData = Awaited<ReturnType<typeof user>>,
	TError = ErrorType<PraetoidError>
>(
	options: {
		query: Partial<UseQueryOptions<Awaited<ReturnType<typeof user>>, TError, TData>> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof user>>,
					TError,
					Awaited<ReturnType<typeof user>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useUser<
	TData = Awaited<ReturnType<typeof user>>,
	TError = ErrorType<PraetoidError>
>(
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof user>>, TError, TData>> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof user>>,
					TError,
					Awaited<ReturnType<typeof user>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useUser<
	TData = Awaited<ReturnType<typeof user>>,
	TError = ErrorType<PraetoidError>
>(
	options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof user>>, TError, TData>> },
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get current user
 */

export function useUser<
	TData = Awaited<ReturnType<typeof user>>,
	TError = ErrorType<PraetoidError>
>(
	options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof user>>, TError, TData>> },
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getUserQueryOptions(options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Sends an email confirmation link to the current user's email address
 * @summary Send email confirmation
 */
export const sendConfirmationEmail = () => {
	return customInstance<SuccessResponse>({ url: `/account/email/confirm`, method: 'POST' });
};

export const getSendConfirmationEmailMutationOptions = <
	TError = ErrorType<PraetoidError>,
	TContext = unknown
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof sendConfirmationEmail>>,
		TError,
		void,
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof sendConfirmationEmail>>,
	TError,
	void,
	TContext
> => {
	const mutationKey = ['sendConfirmationEmail'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof sendConfirmationEmail>>,
		void
	> = () => {
		return sendConfirmationEmail();
	};

	return { mutationFn, ...mutationOptions };
};

export type SendConfirmationEmailMutationResult = NonNullable<
	Awaited<ReturnType<typeof sendConfirmationEmail>>
>;

export type SendConfirmationEmailMutationError = ErrorType<PraetoidError>;

/**
 * @summary Send email confirmation
 */
export const useSendConfirmationEmail = <TError = ErrorType<PraetoidError>, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof sendConfirmationEmail>>,
			TError,
			void,
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof sendConfirmationEmail>>, TError, void, TContext> => {
	return useMutation(getSendConfirmationEmailMutationOptions(options), queryClient);
};
/**
 * Confirms email address using the provided token
 * @summary Confirm email
 */
export const confirmConfirmationEmail = (token: string) => {
	return customInstance<SuccessResponse>({
		url: `/account/email/confirm/${token}`,
		method: 'PATCH'
	});
};

export const getConfirmConfirmationEmailMutationOptions = <
	TError = ErrorType<PraetoidError>,
	TContext = unknown
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof confirmConfirmationEmail>>,
		TError,
		{ token: string },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof confirmConfirmationEmail>>,
	TError,
	{ token: string },
	TContext
> => {
	const mutationKey = ['confirmConfirmationEmail'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof confirmConfirmationEmail>>,
		{ token: string }
	> = (props) => {
		const { token } = props ?? {};

		return confirmConfirmationEmail(token);
	};

	return { mutationFn, ...mutationOptions };
};

export type ConfirmConfirmationEmailMutationResult = NonNullable<
	Awaited<ReturnType<typeof confirmConfirmationEmail>>
>;

export type ConfirmConfirmationEmailMutationError = ErrorType<PraetoidError>;

/**
 * @summary Confirm email
 */
export const useConfirmConfirmationEmail = <TError = ErrorType<PraetoidError>, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof confirmConfirmationEmail>>,
			TError,
			{ token: string },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<
	Awaited<ReturnType<typeof confirmConfirmationEmail>>,
	TError,
	{ token: string },
	TContext
> => {
	return useMutation(getConfirmConfirmationEmailMutationOptions(options), queryClient);
};
/**
 * Sends a confirmation email to update the user's email address
 * @summary Request email update
 */
export const sendUpdateEmail = (updateEmailRequest: UpdateEmailRequest) => {
	return customInstance<MessageResponse>({
		url: `/account/email/update`,
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		data: updateEmailRequest
	});
};

export const getSendUpdateEmailMutationOptions = <
	TError = ErrorType<PraetoidError>,
	TContext = unknown
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof sendUpdateEmail>>,
		TError,
		{ data: UpdateEmailRequest },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof sendUpdateEmail>>,
	TError,
	{ data: UpdateEmailRequest },
	TContext
> => {
	const mutationKey = ['sendUpdateEmail'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof sendUpdateEmail>>,
		{ data: UpdateEmailRequest }
	> = (props) => {
		const { data } = props ?? {};

		return sendUpdateEmail(data);
	};

	return { mutationFn, ...mutationOptions };
};

export type SendUpdateEmailMutationResult = NonNullable<
	Awaited<ReturnType<typeof sendUpdateEmail>>
>;
export type SendUpdateEmailMutationBody = UpdateEmailRequest;
export type SendUpdateEmailMutationError = ErrorType<PraetoidError>;

/**
 * @summary Request email update
 */
export const useSendUpdateEmail = <TError = ErrorType<PraetoidError>, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof sendUpdateEmail>>,
			TError,
			{ data: UpdateEmailRequest },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<
	Awaited<ReturnType<typeof sendUpdateEmail>>,
	TError,
	{ data: UpdateEmailRequest },
	TContext
> => {
	return useMutation(getSendUpdateEmailMutationOptions(options), queryClient);
};
/**
 * Updates the user's email address using the confirmation token
 * @summary Update email
 */
export const confirmUpdateEmail = (token: string) => {
	return customInstance<MessageResponse>({
		url: `/account/email/update/${token}`,
		method: 'PATCH'
	});
};

export const getConfirmUpdateEmailMutationOptions = <
	TError = ErrorType<PraetoidError>,
	TContext = unknown
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof confirmUpdateEmail>>,
		TError,
		{ token: string },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof confirmUpdateEmail>>,
	TError,
	{ token: string },
	TContext
> => {
	const mutationKey = ['confirmUpdateEmail'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof confirmUpdateEmail>>,
		{ token: string }
	> = (props) => {
		const { token } = props ?? {};

		return confirmUpdateEmail(token);
	};

	return { mutationFn, ...mutationOptions };
};

export type ConfirmUpdateEmailMutationResult = NonNullable<
	Awaited<ReturnType<typeof confirmUpdateEmail>>
>;

export type ConfirmUpdateEmailMutationError = ErrorType<PraetoidError>;

/**
 * @summary Update email
 */
export const useConfirmUpdateEmail = <TError = ErrorType<PraetoidError>, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof confirmUpdateEmail>>,
			TError,
			{ token: string },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<
	Awaited<ReturnType<typeof confirmUpdateEmail>>,
	TError,
	{ token: string },
	TContext
> => {
	return useMutation(getConfirmUpdateEmailMutationOptions(options), queryClient);
};
/**
 * Sends a password reset link to the provided email address
 * @summary Request password reset
 */
export const sendResetPassword = (emailRequest: EmailRequest) => {
	return customInstance<MessageResponse>({
		url: `/account/password/reset`,
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		data: emailRequest
	});
};

export const getSendResetPasswordMutationOptions = <
	TError = ErrorType<unknown>,
	TContext = unknown
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof sendResetPassword>>,
		TError,
		{ data: EmailRequest },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof sendResetPassword>>,
	TError,
	{ data: EmailRequest },
	TContext
> => {
	const mutationKey = ['sendResetPassword'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof sendResetPassword>>,
		{ data: EmailRequest }
	> = (props) => {
		const { data } = props ?? {};

		return sendResetPassword(data);
	};

	return { mutationFn, ...mutationOptions };
};

export type SendResetPasswordMutationResult = NonNullable<
	Awaited<ReturnType<typeof sendResetPassword>>
>;
export type SendResetPasswordMutationBody = EmailRequest;
export type SendResetPasswordMutationError = ErrorType<unknown>;

/**
 * @summary Request password reset
 */
export const useSendResetPassword = <TError = ErrorType<unknown>, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof sendResetPassword>>,
			TError,
			{ data: EmailRequest },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<
	Awaited<ReturnType<typeof sendResetPassword>>,
	TError,
	{ data: EmailRequest },
	TContext
> => {
	return useMutation(getSendResetPasswordMutationOptions(options), queryClient);
};
/**
 * Resets the user's password using the provided token
 * @summary Reset password
 */
export const confirmResetPassword = (token: string, resetPasswordRequest: ResetPasswordRequest) => {
	return customInstance<MessageResponse>({
		url: `/account/password/reset/${token}`,
		method: 'PATCH',
		headers: { 'Content-Type': 'application/json' },
		data: resetPasswordRequest
	});
};

export const getConfirmResetPasswordMutationOptions = <
	TError = ErrorType<PraetoidError>,
	TContext = unknown
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof confirmResetPassword>>,
		TError,
		{ token: string; data: ResetPasswordRequest },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof confirmResetPassword>>,
	TError,
	{ token: string; data: ResetPasswordRequest },
	TContext
> => {
	const mutationKey = ['confirmResetPassword'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof confirmResetPassword>>,
		{ token: string; data: ResetPasswordRequest }
	> = (props) => {
		const { token, data } = props ?? {};

		return confirmResetPassword(token, data);
	};

	return { mutationFn, ...mutationOptions };
};

export type ConfirmResetPasswordMutationResult = NonNullable<
	Awaited<ReturnType<typeof confirmResetPassword>>
>;
export type ConfirmResetPasswordMutationBody = ResetPasswordRequest;
export type ConfirmResetPasswordMutationError = ErrorType<PraetoidError>;

/**
 * @summary Reset password
 */
export const useConfirmResetPassword = <TError = ErrorType<PraetoidError>, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof confirmResetPassword>>,
			TError,
			{ token: string; data: ResetPasswordRequest },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<
	Awaited<ReturnType<typeof confirmResetPassword>>,
	TError,
	{ token: string; data: ResetPasswordRequest },
	TContext
> => {
	return useMutation(getConfirmResetPasswordMutationOptions(options), queryClient);
};
/**
 * Updates the user's password after verifying the current password
 * @summary Update password
 */
export const updatePassword = (updatePasswordRequest: UpdatePasswordRequest) => {
	return customInstance<MessageResponse>({
		url: `/account/password/update`,
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		data: updatePasswordRequest
	});
};

export const getUpdatePasswordMutationOptions = <
	TError = ErrorType<PraetoidError>,
	TContext = unknown
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof updatePassword>>,
		TError,
		{ data: UpdatePasswordRequest },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof updatePassword>>,
	TError,
	{ data: UpdatePasswordRequest },
	TContext
> => {
	const mutationKey = ['updatePassword'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof updatePassword>>,
		{ data: UpdatePasswordRequest }
	> = (props) => {
		const { data } = props ?? {};

		return updatePassword(data);
	};

	return { mutationFn, ...mutationOptions };
};

export type UpdatePasswordMutationResult = NonNullable<Awaited<ReturnType<typeof updatePassword>>>;
export type UpdatePasswordMutationBody = UpdatePasswordRequest;
export type UpdatePasswordMutationError = ErrorType<PraetoidError>;

/**
 * @summary Update password
 */
export const useUpdatePassword = <TError = ErrorType<PraetoidError>, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof updatePassword>>,
			TError,
			{ data: UpdatePasswordRequest },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<
	Awaited<ReturnType<typeof updatePassword>>,
	TError,
	{ data: UpdatePasswordRequest },
	TContext
> => {
	return useMutation(getUpdatePasswordMutationOptions(options), queryClient);
};
/**
 * Authenticates a user and creates a session
 * @summary Sign in user
 */
export const signIn = (signInRequest: SignInRequest) => {
	return customInstance<User>({
		url: `/account/signin`,
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		data: signInRequest
	});
};

export const getSignInMutationOptions = <
	TError = ErrorType<PraetoidError>,
	TContext = unknown
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof signIn>>,
		TError,
		{ data: SignInRequest },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof signIn>>,
	TError,
	{ data: SignInRequest },
	TContext
> => {
	const mutationKey = ['signIn'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof signIn>>,
		{ data: SignInRequest }
	> = (props) => {
		const { data } = props ?? {};

		return signIn(data);
	};

	return { mutationFn, ...mutationOptions };
};

export type SignInMutationResult = NonNullable<Awaited<ReturnType<typeof signIn>>>;
export type SignInMutationBody = SignInRequest;
export type SignInMutationError = ErrorType<PraetoidError>;

/**
 * @summary Sign in user
 */
export const useSignIn = <TError = ErrorType<PraetoidError>, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof signIn>>,
			TError,
			{ data: SignInRequest },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<
	Awaited<ReturnType<typeof signIn>>,
	TError,
	{ data: SignInRequest },
	TContext
> => {
	return useMutation(getSignInMutationOptions(options), queryClient);
};
/**
 * Ends the user session and clears authentication cookies
 * @summary Sign out user
 */
export const signOut = () => {
	return customInstance<SuccessResponse>({ url: `/account/signout`, method: 'DELETE' });
};

export const getSignOutMutationOptions = <
	TError = ErrorType<unknown>,
	TContext = unknown
>(options?: {
	mutation?: UseMutationOptions<Awaited<ReturnType<typeof signOut>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof signOut>>, TError, void, TContext> => {
	const mutationKey = ['signOut'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<Awaited<ReturnType<typeof signOut>>, void> = () => {
		return signOut();
	};

	return { mutationFn, ...mutationOptions };
};

export type SignOutMutationResult = NonNullable<Awaited<ReturnType<typeof signOut>>>;

export type SignOutMutationError = ErrorType<unknown>;

/**
 * @summary Sign out user
 */
export const useSignOut = <TError = ErrorType<unknown>, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<Awaited<ReturnType<typeof signOut>>, TError, void, TContext>;
	},
	queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof signOut>>, TError, void, TContext> => {
	return useMutation(getSignOutMutationOptions(options), queryClient);
};
/**
 * Creates a new user account and establishes a session
 * @summary Sign up new user
 */
export const signUp = (signUpRequest: SignUpRequest) => {
	return customInstance<User>({
		url: `/account/signup`,
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		data: signUpRequest
	});
};

export const getSignUpMutationOptions = <
	TError = ErrorType<PraetoidError>,
	TContext = unknown
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof signUp>>,
		TError,
		{ data: SignUpRequest },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof signUp>>,
	TError,
	{ data: SignUpRequest },
	TContext
> => {
	const mutationKey = ['signUp'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof signUp>>,
		{ data: SignUpRequest }
	> = (props) => {
		const { data } = props ?? {};

		return signUp(data);
	};

	return { mutationFn, ...mutationOptions };
};

export type SignUpMutationResult = NonNullable<Awaited<ReturnType<typeof signUp>>>;
export type SignUpMutationBody = SignUpRequest;
export type SignUpMutationError = ErrorType<PraetoidError>;

/**
 * @summary Sign up new user
 */
export const useSignUp = <TError = ErrorType<PraetoidError>, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof signUp>>,
			TError,
			{ data: SignUpRequest },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<
	Awaited<ReturnType<typeof signUp>>,
	TError,
	{ data: SignUpRequest },
	TContext
> => {
	return useMutation(getSignUpMutationOptions(options), queryClient);
};
/**
 * Handles OAuth provider callback and creates user session
 * @summary OAuth provider callback
 */
export const signInOAuthCallback = (provider: string, params?: SignInOAuthCallbackParams) => {
	return customInstance<User>({ url: `/account/${provider}/callback`, method: 'GET', params });
};

export const getSignInOAuthCallbackQueryKey = (
	provider: string,
	params?: SignInOAuthCallbackParams
) => {
	return ['account', provider, 'callback', ...(params ? [params] : [])] as const;
};

export const getSignInOAuthCallbackQueryOptions = <
	TData = Awaited<ReturnType<typeof signInOAuthCallback>>,
	TError = ErrorType<PraetoidError>
>(
	provider: string,
	params?: SignInOAuthCallbackParams,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof signInOAuthCallback>>, TError, TData>
		>;
	}
) => {
	const { query: queryOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getSignInOAuthCallbackQueryKey(provider, params);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof signInOAuthCallback>>> = () =>
		signInOAuthCallback(provider, params);

	return { queryKey, queryFn, enabled: !!provider, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof signInOAuthCallback>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SignInOAuthCallbackQueryResult = NonNullable<
	Awaited<ReturnType<typeof signInOAuthCallback>>
>;
export type SignInOAuthCallbackQueryError = ErrorType<PraetoidError>;

export function useSignInOAuthCallback<
	TData = Awaited<ReturnType<typeof signInOAuthCallback>>,
	TError = ErrorType<PraetoidError>
>(
	provider: string,
	params: undefined | SignInOAuthCallbackParams,
	options: {
		query: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof signInOAuthCallback>>, TError, TData>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof signInOAuthCallback>>,
					TError,
					Awaited<ReturnType<typeof signInOAuthCallback>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSignInOAuthCallback<
	TData = Awaited<ReturnType<typeof signInOAuthCallback>>,
	TError = ErrorType<PraetoidError>
>(
	provider: string,
	params?: SignInOAuthCallbackParams,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof signInOAuthCallback>>, TError, TData>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof signInOAuthCallback>>,
					TError,
					Awaited<ReturnType<typeof signInOAuthCallback>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSignInOAuthCallback<
	TData = Awaited<ReturnType<typeof signInOAuthCallback>>,
	TError = ErrorType<PraetoidError>
>(
	provider: string,
	params?: SignInOAuthCallbackParams,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof signInOAuthCallback>>, TError, TData>
		>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary OAuth provider callback
 */

export function useSignInOAuthCallback<
	TData = Awaited<ReturnType<typeof signInOAuthCallback>>,
	TError = ErrorType<PraetoidError>
>(
	provider: string,
	params?: SignInOAuthCallbackParams,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof signInOAuthCallback>>, TError, TData>
		>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getSignInOAuthCallbackQueryOptions(provider, params, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Initiates OAuth authentication flow with specified provider
 * @summary OAuth provider request
 */
export const signInOAuth = (provider: string) => {
	return customInstance<ProviderResponse>({ url: `/account/${provider}/request`, method: 'GET' });
};

export const getSignInOAuthQueryKey = (provider: string) => {
	return ['account', provider, 'request'] as const;
};

export const getSignInOAuthQueryOptions = <
	TData = Awaited<ReturnType<typeof signInOAuth>>,
	TError = ErrorType<PraetoidError>
>(
	provider: string,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof signInOAuth>>, TError, TData>>;
	}
) => {
	const { query: queryOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getSignInOAuthQueryKey(provider);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof signInOAuth>>> = () =>
		signInOAuth(provider);

	return { queryKey, queryFn, enabled: !!provider, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof signInOAuth>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SignInOAuthQueryResult = NonNullable<Awaited<ReturnType<typeof signInOAuth>>>;
export type SignInOAuthQueryError = ErrorType<PraetoidError>;

export function useSignInOAuth<
	TData = Awaited<ReturnType<typeof signInOAuth>>,
	TError = ErrorType<PraetoidError>
>(
	provider: string,
	options: {
		query: Partial<UseQueryOptions<Awaited<ReturnType<typeof signInOAuth>>, TError, TData>> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof signInOAuth>>,
					TError,
					Awaited<ReturnType<typeof signInOAuth>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSignInOAuth<
	TData = Awaited<ReturnType<typeof signInOAuth>>,
	TError = ErrorType<PraetoidError>
>(
	provider: string,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof signInOAuth>>, TError, TData>> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof signInOAuth>>,
					TError,
					Awaited<ReturnType<typeof signInOAuth>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSignInOAuth<
	TData = Awaited<ReturnType<typeof signInOAuth>>,
	TError = ErrorType<PraetoidError>
>(
	provider: string,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof signInOAuth>>, TError, TData>>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary OAuth provider request
 */

export function useSignInOAuth<
	TData = Awaited<ReturnType<typeof signInOAuth>>,
	TError = ErrorType<PraetoidError>
>(
	provider: string,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof signInOAuth>>, TError, TData>>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getSignInOAuthQueryOptions(provider, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return { ...query, queryKey: queryOptions.queryKey };
}
